import React, { useRef } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import useModalA11y from "./useModalA11y";
import "./ui.scss";

/** Label / value list used inside the drawer. items: [{ label, value }] */
export const DetailList = ({ items }) => (
  <dl className="hr-detail">
    {items.map((item) => (
      <div className="hr-detail__row" key={item.label}>
        <dt>{item.label}</dt>
        <dd>{item.value}</dd>
      </div>
    ))}
  </dl>
);

/**
 * Right-hand drawer (full width on phones). Escape / overlay click / close
 * button dismiss it; focus is trapped while open and restored on close.
 */
const DetailsDrawer = ({ open, onClose, title, badge, children, footer }) => {
  const panelRef = useRef(null);
  const closeRef = useRef(null);

  useModalA11y({
    open,
    onClose,
    containerRef: panelRef,
    initialFocusRef: closeRef,
  });

  if (!open) return null;

  return createPortal(
    <div className="hr-drawer-root">
      <div className="hr-drawer-overlay" onClick={onClose} aria-hidden="true" />
      <aside
        ref={panelRef}
        className="hr-drawer"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hr-drawer-title"
        tabIndex={-1}
      >
        <header className="hr-drawer__header">
          <h2 id="hr-drawer-title">{title}</h2>
          {badge}
          <button
            ref={closeRef}
            type="button"
            className="hr-iconbtn"
            aria-label="Close details"
            onClick={onClose}
          >
            <X size={18} aria-hidden="true" />
          </button>
        </header>
        <div className="hr-drawer__body">{children}</div>
        {footer && <footer className="hr-drawer__footer">{footer}</footer>}
      </aside>
    </div>,
    document.body,
  );
};

export default DetailsDrawer;
